// extracted by mini-css-extract-plugin
module.exports = {"checkboxMargin":"style_checkboxMargin__1xdKw","title":"style_title__1Xp-t","checkboxNote":"style_checkboxNote__NkCti","message":"style_message__1B7Sk"};